import React from 'react';

import ArticleList from '../../../react4xp/components/ArticleList';
import Section from '../../../react4xp/components/Section';

function ArticleListPart(props) {
	return (
		<Section>
			<ArticleList 
				title={props.title}
				highlightedCard={props.highlightedArticle ? {
					title: props.highlightedArticle.title,
					isHighlighted: true,
					img: {
						src: props.highlightedArticle.src?.link,
						srcMobile: props.highlightedArticle.srcMobile?.link,
						alt: props.highlightedArticle.image?.alt
					},
					url: props.highlightedArticle.url,
					badges: {
						insights: props.highlightedArticle.type === 'insights',
						news: props.highlightedArticle.type === 'news'
					},
					customBadges: props.highlightedArticle.customBadges
				} : undefined}
				cards={props.articles.map(article => ({
					title: article.title,
					img: {
						src: article?.src?.link,
						alt: article?.image?.alt
					},
					url: article.url,
					badges: {
						insights: article?.type === 'insights',
						news: article?.type === 'news'
					},
					customBadges: article?.customBadges
				}))}
				cta={props.cta || undefined}
			/>
		</Section>
	)
}

export default (props) => <ArticleListPart {...props} />
